var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-2 py-2",class:_vm.b()},[_c('div',{class:_vm.b('title')},[_vm._v("Resumen")]),_c('div',{class:_vm.b('content'),domProps:{"innerHTML":_vm._s(_vm.description)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }